import { ApolloCache } from '@apollo/client';

const doEvictAllOfTypes = (
  cache: ApolloCache<object>,
  typesToEvict: string[]
) => {
  // Hämta alla cacheposter och filtrera ut de som matchar de angivna typerna.
  const allKeys: string[] = Object.keys(cache.extract());
  typesToEvict.forEach(typeName => {
    allKeys.forEach(key => {
      if (key.startsWith(typeName + ':')) {
        cache.evict({ id: key });
      }
    });
  });
  cache.gc();
};

/**
 * Skapar en funktion som bort alla cacheposter av de angivna typerna från Apollo-cachen.
 * @param typesToEvict Array med typnamn som ska tas bort från cachen.
 * @returns En funktion som tar bort cacheposter av de angivna typerna, när den anropas med en Apollo-cacheinstans.
 */
export const evictAllOfTypes =
  (typesToEvict: string[]) => (cache: ApolloCache<object>) => {
    doEvictAllOfTypes(cache, typesToEvict);
  };
